import { fg } from '@atlassian/jira-feature-gating';

const RemoveCanSetIssueRestrictionFromLinkedIssuesRelayProvider = {
	get(): boolean {
		return fg('flash960_remove_linkedissue_cansetissuerestriction');
	},
};

export default RemoveCanSetIssueRestrictionFromLinkedIssuesRelayProvider;
